// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 63 ? "ImportFuncDemo" : chunkId) + "." + {"63":"329f4cf5","437":"41ac7ccb"}[chunkId] + ".css";
};